export default __webpack_public_path__ + "static/media/header.9d3a5f91.less";